class CreateAndPrintVouchersForInvoices {
    constructor(Alert, $http, locale, ResourceCommon) {
        this.key = 'create-and-print-vouchers-for-invoices';
        this.title = 'Create and print Vouchers';
        this.level = 'selected';
        this.alert = Alert;
        this.locale = locale;
        this.api = $http;
        this.resourceCommon = ResourceCommon;
    }

    action({}, store) {
        return this.locale.ready(['categories', 'sweetalerts'])
            .then(() => {
                this.api.post('vouchers/create-and-print-for-invoices', {
                    invoices: store.getters.selectedFilters
                }).then(() => {
                    store.dispatch('getData');
                    this.alert.success('Job scheduled', 'The job was scheduled. The vouchers will be generated and printed now.');
                }, err => this.alert.handle(err))
            });
    }
}

angular
    .module('festzelt-os.billing.invoices')
    .factory('createAndPrintVouchersForInvoices', [
        'Alert',
        '$http',
        'locale',
        'ResourceCommon',
        (Alert, $http, locale, ResourceCommon) => new CreateAndPrintVouchersForInvoices(Alert, $http, locale, ResourceCommon)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/create-voucher-export-for-invoices.js